import script from "./SiteBannerList.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteBannerList.vue?vue&type=script&setup=true&lang=js"

import "./SiteBannerList.vue?vue&type=style&index=0&id=35699ebf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35699ebf"]])

export default __exports__